module.exports = __webpack_public_path__ + "static/home-db7c28acb6d903a899e57cc6799d4598.jpg";